export const popularFacilities = [
  '1 swimming pool per room',
  'Free WiFi',
  'Airport shuttle',
  'Non-smoking rooms',
  'Room service',
  'Free parking',
  'Restaurant',
  'Family rooms',
  'Tea/coffee maker in all rooms',
  'Breakfast'
];

export const facilityGroups = [
  {
    title: 'Bathroom',
    items: ['Towels', 'Bath or shower', 'Private bathroom', 'Toilet', 'Free toiletries', 'Hairdryer', 'Bath', 'Shower']
  },
  {
    title: 'Bedroom',
    items: ['Linen', 'Wardrobe or closet', 'View', 'Garden view']
  },
  {
    title: 'Outdoors',
    items: ['Outdoor fireplace', 'Outdoor furniture', 'Outdoor dining area', 'Sun terrace', 'Barbecue', 'Private pool', 'BBQ facilities (additional charge)', 'Terrace', 'Garden']
  },
  {
    title: 'Kitchen',
    items: ['Dining table', 'Cleaning products', 'Tumble dryer', 'Electric kettle', 'Refrigerator']
  },
  {
    title: 'Room amenities',
    items: ['Socket near the bed', 'Drying rack for clothing', 'Clothes rack']
  },
  {
    title: 'Activities',
    items: ['Cooking class (additional charge)', 'Tour or class about local culture (additional charge)', 'Themed dinner nights (additional charge)', 'Walking tours (additional charge)', 'Fishing (additional charge, off-site)']
  },
  {
    title: 'Living area',
    items: ['Dining area', 'Seating area', 'Desk']
  },
  {
    title: 'Food & drink',
    items: ['Coffee house on site', 'Fruits (additional charge)', 'Wine/champagne (additional charge)', 'Kid-friendly buffet', 'Kids’ meals (additional charge)', 'Special diet menus on request', 'Breakfast in the room', 'Minibar', 'Restaurant', 'Tea/coffee maker']
  },
  {
    title: 'Internet & parking',
    items: ['WiFi is available in all areas and is free of charge', 'Free private parking is possible on site; reservation is needed']
  },
  {
    title: 'Reception services',
    items: ['Invoice provided', 'Lockers', 'Private check-in/check-out', 'Concierge service', 'Luggage storage', 'Tour desk', 'Express check-in/check-out', '24-hour front desk']
  },
  {
    title: 'Cleaning services',
    items: ['Daily housekeeping', 'Ironing service (additional charge)']
  },
  {
    title: 'Business facilities',
    items: ['Fax/photocopying']
  },
  {
    title: 'Safety & security',
    items: ['Fire extinguishers', 'CCTV outside the property', 'CCTV in common areas', 'Security alarm', '24-hour security', 'Safety deposit box']
  },
  {
    title: 'General',
    items: ['Shuttle service (additional charge)', 'Shared lounge/TV area', 'Designated smoking area', 'Air conditioning', 'Hardwood or parquet floors', 'Private entrance', 'Packed lunches', 'Family rooms', 'Ironing facilities', 'Airport shuttle (additional charge)', 'Non-smoking rooms', 'Room service']
  },
  {
    title: 'Swimming pool',
    items: [
      'One private outdoor swimming pool per room: free, open all year, all ages welcome, plunge pool, pool/beach towels, sun loungers or beach chairs'
    ]
  },
  {
    title: 'Wellness',
    items: ['Sun loungers or beach chairs']
  },
  {
    title: 'Languages spoken',
    items: ['English', 'Hindi']
  }
];

export const houseRules = [
  {
    title: 'Special requests',
    items: ['Leopard Bliss Yala takes special requests. Add them during the next step of booking.']
  },
  {
    title: 'Check-in',
    items: ['From 14:00 to 20:00', 'Guests are required to show photo identification and a credit card at check-in.', 'Please let the property know your arrival time in advance.']
  },
  {
    title: 'Check-out',
    items: ['From 11:00 to 12:00']
  },
  {
    title: 'Cancellation and prepayment',
    items: ['Policies vary according to accommodation type. Enter your dates to check the conditions for your selected option.']
  },
  {
    title: 'Children and beds',
    items: ['Children of any age are welcome.', 'Guests aged 17 and above are charged as adults.', 'For correct prices and occupancy, include the number and ages of children in your search.', 'Cots for children aged 0–3 are available on request, free of charge, subject to availability.', 'The number of cots depends on the option selected.', 'Extra beds are not available.']
  },
  {
    title: 'Other policies',
    items: ['No age restriction for check-in.', 'Pets are not allowed.', 'Bookings of more than 2 rooms may have different policies and additional supplements.', 'Smoking is not allowed.', 'Parties and events are not allowed.']
  },
  {
    title: 'Breakfast',
    items: ['Continental, Full English/Irish, Vegetarian, Vegan, Halal, Gluten-free, Asian, American, and breakfast to go.']
  },
  {
    title: 'Parking',
    items: ['Free private parking is available on site. Reservation is needed.']
  }
];